import { isNil } from 'ramda';

export const getStreetWithNumber = (street, streetNo) => {
	if (isNil(street)) {
		return null;
	} else {
		if (isNil(streetNo)) {
			return street;
		} else {
			return `${street} ${streetNo}`;
		}
	}
};
